import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider } from "@aws-amplify/ui-react";
import { Amplify } from 'aws-amplify';

import awsconfig from './aws-exports';

import "@aws-amplify/ui-react/styles.css";
import { studioTheme } from "./ui-components";

Amplify.configure(awsconfig);

// Amplify.configure({
//   Auth: {
//       identityPoolId: 'ap-northeast-1:e689a13f-5ff0-442b-af97-c06b722b56ed',
//       region: 'ap-northeast-1',
//       userPoolId: 'ap-northeast-1_GPiRd5uTp',
//       mandatorySignIn: false,
//       userPoolWebClientId: 'ihvv6edu7g6t7qqrjap956l79'
//   },
//   Storage: {
//       bucket: 'data-670634105186110322-staging',
//       region: 'ap-northeast-1',
//       identityPoolId: 'ap-northeast-1:e689a13f-5ff0-442b-af97-c06b722b56ed'
//   }
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ThemeProvider theme={studioTheme}>
      <App />
    </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
